<template>
  <Row :gutter="24" class="tableCell">
    <Col class="col-cell" v-for="(item, index) in dataCol" :span="item"
         style="border: rgba(0,0,0,0.41) solid 1px;"
         :style="{height: height, 'line-height': lineHeight,
         'background-color': (bgBlue.indexOf(index) > -1) ? 'rgba(129, 211, 248, 0.298039215686275)' :
         ((bgGrey.indexOf(index) > -1) ? 'rgba(242, 242, 242, 0.596078431372549)' :  '#fff') }">
      <slot v-for="i in slotCount" :name="'inner'+i" v-if="(index+1) == i"/>
    </Col>
  </Row>
<!-- IForm -->
</template>
<script>
export default {
  name: "Search",
  props: {
    height: {
      type: String,
      default: ()=>{return "40px"}
    },
    slotCount: Number,
    dataCol: Array,
    bgBlue: {
      type: Array,
      default: ()=>{return []}
    },
    bgGrey: {
      type: Array,
      default: ()=>{return []}
    },
  },
  computed:{
    lineHeight: {
      get() { return this.tempLineHeight;},
      set(newValue) {
         this.tempLineHeight = newValue;
      }
    }
  },
  data: () => ({
    tempLineHeight:''
  }),
  methods: {
    setLineHeight(){
      let screenWidth = document.body.clientWidth
      if (screenWidth < 1500){
        this.tempLineHeight = '';
      }else {
        this.tempLineHeight = this.$props.height;
      }
    }
  },
  mounted() {
    this.setLineHeight();
    window.onresize = () => {
      //屏幕尺寸变化
      this.setLineHeight();
    }
  }
};
</script>
<style lang="postcss" scoped>
.col-cell{
  text-align: center;
}
</style>
